"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var THREE = _interopRequireWildcard(require("three"));
var _reactThreeFiber = require("react-three-fiber");
var _GLTFLoader = require("three/examples/jsm/loaders/GLTFLoader");
var _OrbitControls = require("three/examples/jsm/controls/OrbitControls");
var _SSAOPass = require("three/examples/jsm/postprocessing/SSAOPass");
var _EffectComposer = require("three/examples/jsm/postprocessing/EffectComposer");
var _PlanCell = require("./PlanCell");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function GltfView(_ref) {
  var page = _ref.page,
    uri = _ref.uri,
    intl = _ref.intl,
    setCatSelected = _ref.setCatSelected,
    defaultLanguage = _ref.defaultLanguage,
    expoSelected = _ref.expoSelected,
    colorSelected = _ref.colorSelected,
    expos = _ref.expos,
    setSelected = _ref.setSelected,
    uriTransformer = _ref.uriTransformer,
    logEvent = _ref.logEvent,
    cell = _ref.cell,
    currentCategory = _ref.currentCategory,
    onLoad = _ref.onLoad,
    selectionSourceRef = _ref.selectionSourceRef;
  var gltfRef = (0, _react.useRef)();
  var gltfLoader = new _GLTFLoader.GLTFLoader();
  var _ref2 = (0, _reactThreeFiber.useThree)(),
    setDefaultCamera = _ref2.setDefaultCamera,
    gl = _ref2.gl,
    raycaster = _ref2.raycaster;
  var cameraRef = (0, _react.useRef)(new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000));
  var cameraNoPerspective = (0, _react.useRef)(new THREE.OrthographicCamera());
  var controlsRef = (0, _react.useRef)(null);
  var initialCameraState = (0, _react.useRef)(null);
  var standsMeshesRef = (0, _react.useRef)([]);
  var _ref3 = (0, _react.useState)(false),
    _ref4 = _slicedToArray(_ref3, 2),
    isDragging = _ref4[0],
    setIsDragging = _ref4[1];
  var _ref5 = (0, _react.useState)({
      x: 0
    }),
    _ref6 = _slicedToArray(_ref5, 2),
    prevMousePosition = _ref6[0],
    setPrevMousePosition = _ref6[1];
  var _ref7 = (0, _react.useState)({}),
    _ref8 = _slicedToArray(_ref7, 2),
    colors = _ref8[0],
    setColors = _ref8[1];
  var _ref9 = (0, _react.useState)(null),
    _ref0 = _slicedToArray(_ref9, 2),
    scene = _ref0[0],
    setScene = _ref0[1];
  var _ref1 = (0, _react.useState)(false),
    _ref10 = _slicedToArray(_ref1, 2),
    planLoaded = _ref10[0],
    setPlanLoaded = _ref10[1];

  // === Smooth camera animation ===
  var easeInOut = function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  };
  var animateCamera = function animateCamera(camera, controls, _ref11) {
    var fromPosition = _ref11.fromPosition,
      toPosition = _ref11.toPosition,
      fromZoom = _ref11.fromZoom,
      toZoom = _ref11.toZoom,
      fromTarget = _ref11.fromTarget,
      toTarget = _ref11.toTarget;
    var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    var start = performance.now();
    var _animate = function animate(time) {
      var elapsed = time - start;
      var t = Math.min(elapsed / duration, 1);

      // 🔹 Position & target → linéaire (plan stable)
      camera.position.lerpVectors(fromPosition, toPosition, t);
      controls.target.lerpVectors(fromTarget, toTarget, t);

      // 🔹 Zoom → easing uniquement
      var easedZoom = easeInOut(t);
      camera.zoom = THREE.MathUtils.lerp(fromZoom, toZoom, easedZoom);
      camera.updateProjectionMatrix();
      controls.update();
      if (t < 1) requestAnimationFrame(_animate);
    };
    requestAnimationFrame(_animate);
  };
  var handleMouseDown = function handleMouseDown(event) {
    setIsDragging(true);
    setPrevMousePosition({
      x: event.clientX
    });
  };
  var handleMouseUp = function handleMouseUp() {
    setIsDragging(false);
  };
  var handleMouseMove = function handleMouseMove(event) {
    if (!isDragging) return;
    var clientX = event.clientX;
    var deltaX = clientX - prevMousePosition.x;

    //gltfRef.current.rotation.y += deltaX * 0;

    setPrevMousePosition({
      x: clientX
    });
  };

  // Fonction de zoom sur un mesh (zoom fixe de 380)
  // === Préparer le zoom sur un mesh ===
  var zoomOnMesh = function zoomOnMesh(mesh) {
    if (!cameraNoPerspective.current || !controlsRef.current || !initialCameraState.current) return;

    // ✅ Pré-calculer la Box3 et le centre
    if (!mesh.userData.boundingBox) {
      mesh.userData.boundingBox = new THREE.Box3().setFromObject(mesh);
      mesh.userData.center = mesh.userData.boundingBox.getCenter(new THREE.Vector3());
    }
    var center = mesh.userData.center;

    // Calcul de l'offset initial (distance entre caméra et target)
    var offset = new THREE.Vector3().subVectors(initialCameraState.current.position, initialCameraState.current.target);

    // === Optimisation de l'animation ===
    var fromPos = cameraNoPerspective.current.position.clone();
    var toPos = center.clone().add(offset);
    var fromTarget = controlsRef.current.target.clone();
    var toTarget = center.clone();
    var fromZoom = cameraNoPerspective.current.zoom;
    var toZoom = 380; // zoom fixe

    var duration = 500; // plus rapide et plus léger
    var start = performance.now();
    var _animate2 = function animate(time) {
      var t = Math.min((time - start) / duration, 1);

      // Position & target → linéaire
      cameraNoPerspective.current.position.lerpVectors(fromPos, toPos, t);
      controlsRef.current.target.lerpVectors(fromTarget, toTarget, t);

      // Zoom → easing léger
      var eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      cameraNoPerspective.current.zoom = THREE.MathUtils.lerp(fromZoom, toZoom, eased);
      cameraNoPerspective.current.updateProjectionMatrix();
      controlsRef.current.update();
      if (t < 1) requestAnimationFrame(_animate2);
    };
    requestAnimationFrame(_animate2);
  };

  // Fonction de reset de la caméra
  var resetCamera = function resetCamera() {
    if (!initialCameraState.current || !cameraNoPerspective.current || !controlsRef.current) return;
    animateCamera(cameraNoPerspective.current, controlsRef.current, {
      fromPosition: cameraNoPerspective.current.position.clone(),
      toPosition: initialCameraState.current.position.clone(),
      fromZoom: cameraNoPerspective.current.zoom,
      toZoom: initialCameraState.current.zoom,
      fromTarget: controlsRef.current.target.clone(),
      toTarget: initialCameraState.current.target.clone()
    });
  };
  (0, _react.useEffect)(function () {
    if (!uri) return;
    gltfLoader.load(uri, function (gltf) {
      var loadedScene = gltf.scene;
      loadedScene.rotateY(Math.PI);

      //Small left move to improve batibouw plan
      // loadedScene.position.x += 0.1;

      var Dlight = new THREE.DirectionalLight(0xFFFFFF, 1.3);
      Dlight.position.set(-300, 250, 100);
      var Dlight2 = new THREE.DirectionalLight(0xFFFFFF, 0.34);
      Dlight2.position.set(200, 50, -60);
      var Dlight3 = new THREE.DirectionalLight(0xFFFFFF, 0.28);
      Dlight3.position.set(100, 50, -100);
      var spot = new THREE.AmbientLight(0xFFFFFF, 0.3);
      spot.position.set(10, 10, 8);
      gltfRef.current = loadedScene;
      setScene(loadedScene);
      var boundingBox = new THREE.Box3().setFromObject(loadedScene);
      var boxSize = new THREE.Vector3();
      boundingBox.getSize(boxSize);
      var boxCenter = new THREE.Vector3();
      var center = boundingBox.getCenter(new THREE.Vector3());
      var size = boundingBox.getSize(new THREE.Vector3());
      var distance = Math.max(size.x, size.y, size.z) / 0.84;
      var fov = cameraRef.current.fov * (Math.PI / 180);
      var cameraZ = Math.abs(distance / 2 * Math.tan(fov * 1)) / 4;
      var cameray = Math.abs(distance / 2 * Math.tan(fov * 1)) / 14;
      cameraRef.current.position.copy(center);
      cameraRef.current.position.y += cameray / 2;
      cameraRef.current.position.z += cameraZ;
      cameraRef.current.position.x -= cameraZ / 8;
      var composer = new _EffectComposer.EffectComposer(gl);
      var pass = new _SSAOPass.SSAOPass(loadedScene, cameraNoPerspective.current);
      pass.kernelRadius = 40;
      pass.minDistance = 0.001;
      pass.maxDistance = 0.3;
      composer.addPass(pass);

      // Calcul de la taille maximale de la boîte englobante
      var maxSize = Math.max(boxSize.x, boxSize.y, boxSize.z);

      // Calcul des paramètres de la caméra orthographique en fonction de la boîte englobante
      var cameraHalfWidth = maxSize / 2;
      var cameraHalfHeight = maxSize / 2;
      var near = 0.1;
      var far = 1000;
      var zoom = 0.14;
      cameraNoPerspective.current = new THREE.OrthographicCamera(-cameraHalfWidth * zoom, cameraHalfWidth * zoom, cameraHalfHeight * zoom, -cameraHalfHeight * zoom, near, far);
      cameraNoPerspective.current.position.x -= cameraZ;
      cameraNoPerspective.current.position.y += cameraZ * 0.8;
      cameraNoPerspective.current.position.z += cameraZ;

      //smaller zoom to batibouw normal value : 290
      cameraNoPerspective.current.zoom = 290;
      var controller = new _OrbitControls.MapControls(cameraNoPerspective.current, gl.domElement);
      controller.minDistance = distance / 2;
      controller.maxDistance = distance * 0.8;

      // Activer le panning (déplacement avec clic gauche ou toucher)
      controller.enablePan = true;
      controller.screenSpacePanning = true; // Déplacement dans l'espace écran (plus intuitif)
      controller.mouseButtons = {
        LEFT: THREE.MOUSE.PAN,
        // Clic gauche pour déplacer
        MIDDLE: THREE.MOUSE.DOLLY,
        // Molette pour zoom
        RIGHT: THREE.MOUSE.PAN // Clic droit aussi pour déplacer
      };
      controlsRef.current = controller;
      var standsMeshes = [];
      loadedScene.traverse(function (child) {
        child.castShadow = true;
        child.receiveShadow = true;
        if (child.isMesh) {
          standsMeshes.push(child);
        }
      });

      // Sauvegarde des meshes pour utilisation ultérieure
      standsMeshesRef.current = standsMeshes;
      gl.domElement.addEventListener("click", function (event) {
        event.stopPropagation();
        var clickedMeshes = raycaster.intersectObjects(standsMeshes);
        if (clickedMeshes.length > 0) {
          var clickedMesh = clickedMeshes[0].object;
          var clickedExpos = expos.filter(function (expo) {
            var stand_number_plan = clickedMesh.name.replace('stand-', '').replace(' ', '');
            if (stand_number_plan === expo.expo_number) {
              logEvent('click', {
                cellId: cell.id,
                pageId: page.id,
                languageCode: intl.locale,
                expoName: expo.expo_name,
                expoNumber: expo.expo_number
              });
            }
            return stand_number_plan === expo.expo_number;
          });
          if (clickedExpos.length > 0) {
            selectionSourceRef.current = 'map'; // 👈 IMPORTANT
            setCatSelected('');
            setSelected(clickedExpos);
            // setCurrentDetailExpo(clickedExpos[0]);
            return;
          }
        }

        // clic hors stand → reset
        selectionSourceRef.current = null;
        setSelected([]);
        resetCamera();
      });
      var minPan = new THREE.Vector3(-distance / 3, -distance / 3, -distance / 3);
      var maxPan = new THREE.Vector3(distance / 3, distance / 3, distance / 3);
      var _v = new THREE.Vector3();
      controller.enableRotate = false;
      controller.addEventListener("change", function () {
        _v.copy(controller.target);
        controller.target.clamp(minPan, maxPan);
        _v.sub(controller.target);
        cameraNoPerspective.current.position.sub(_v);
      });

      // Sauvegarde de l'état initial de la caméra
      initialCameraState.current = {
        position: cameraNoPerspective.current.position.clone(),
        zoom: cameraNoPerspective.current.zoom,
        target: center.clone()
      };
      setDefaultCamera(cameraNoPerspective.current);
      setPlanLoaded(true);
      if (onLoad) onLoad();
    });
  }, [uri]);
  (0, _react.useEffect)(function () {
    if (gltfRef.current && gltfRef.current.traverse) {
      try {
        gltfRef.current.traverse(function (child) {
          if (child.type === "Sprite") {
            gltfRef.current.remove(child);
          }
          if (child.isMesh) {
            if (!colors[child.name]) {
              setColors(function (prevColors) {
                return _objectSpread(_objectSpread({}, prevColors), {}, _defineProperty({}, child.name, child.material.color.clone()));
              });
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
      ;
      try {
        var selectedExpoNumbers = expoSelected.map(function (expo) {
          return expo.expo_number.replace(' ', '');
        });

        // Zoom sur le stand sélectionné depuis la liste
        // 🔒 Zoom UNIQUEMENT si la sélection vient de la LISTE
        if (selectionSourceRef.current === 'list' && expoSelected.length === 1 && standsMeshesRef.current.length > 0) {
          var selectedExpoNumber = expoSelected[0].expo_number.replace(' ', '');
          var selectedMesh = standsMeshesRef.current.find(function (mesh) {
            var standNumber = mesh.name.replace('stand-', '').replace(' ', '');
            return standNumber === selectedExpoNumber;
          });
          if (selectedMesh) {
            zoomOnMesh(selectedMesh);
          }

          // reset après usage
          selectionSourceRef.current = null;
        }
        // } else if (expoSelected.length === 0) {
        //   // Dézoom si aucun exposant sélectionné
        //   resetCamera();
        // }

        gltfRef.current.traverse(function (child) {
          if (child.isMesh) {
            var stand_number_plan = child.name.replace('stand-', '').replace(' ', '');
            var isSelectedExpo = expoSelected.some(function (expo) {
              return expo.expo_number.replace(' ', '') === stand_number_plan;
            });
            var isInSelectedCategory = currentCategory ? expos.some(function (expo) {
              return (0, _PlanCell.verifyCatIsInside)(intl, defaultLanguage, expo.categories, currentCategory) && expo.expo_number.replace(' ', '') === stand_number_plan;
            }) : false;

            // 🔹 Stands exposant sélectionné
            if (isSelectedExpo) {
              if (!child.userData.originalMaterial) {
                child.userData.originalMaterial = child.material;
              }
              var newMat = new THREE.MeshBasicMaterial({
                color: new THREE.Color(colorSelected),
                // couleur exposant
                transparent: true,
                opacity: 1
              });
              child.material = newMat;
            }
            // 🔹 Stands appartenant à la catégorie choisie
            else if (isInSelectedCategory) {
              if (!child.userData.originalMaterial) {
                child.userData.originalMaterial = child.material;
              }
              var _newMat = new THREE.MeshBasicMaterial({
                color: new THREE.Color('#3578e5'),
                // couleur neutre catégorie
                transparent: true,
                opacity: 0.3
              });
              child.material = _newMat;
            }
            // 🔹 Tous les autres stands
            else {
              if (child.userData.originalMaterial) {
                child.material = child.userData.originalMaterial;
              }
            }
          } else if (child.type === 'Sprite') {
            gltfRef.current.remove(child);
          }
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      return;
    }
  }, [expoSelected, gltfRef.current, currentCategory, colors]);
  (0, _react.useEffect)(function () {
    window.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('mousemove', handleMouseMove);
    return function () {
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  if (!gltfRef) {
    return /*#__PURE__*/_react.default.createElement(THREE.Box3, null);
  }
  return scene ? /*#__PURE__*/_react.default.createElement("primitive", {
    ref: gltfRef,
    object: scene
  }) : null;
}
var _default = exports.default = GltfView;